/**
 * Viewport Helper Utilities — Phase 2
 * Convert between screen and canvas coordinates.
 */

/** Get the center point of the current viewport in canvas coordinates. */
export function getViewportCenter(viewportState: {
  panX: number;
  panY: number;
  zoom: number;
}): { x: number; y: number } {
  const { panX, panY, zoom } = viewportState;
  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;
  const windowHeight = typeof window !== 'undefined' ? window.innerHeight : 1080;

  return {
    x: (-panX + windowWidth / 2) / zoom,
    y: (-panY + windowHeight / 2) / zoom,
  };
}

/** Get the viewport bounds in canvas coordinates. */
export function getViewportBounds(
  panX: number,
  panY: number,
  zoom: number,
  windowWidth?: number,
  windowHeight?: number
): { left: number; top: number; right: number; bottom: number } {
  const w = windowWidth ?? (typeof window !== 'undefined' ? window.innerWidth : 1920);
  const h = windowHeight ?? (typeof window !== 'undefined' ? window.innerHeight : 1080);

  return {
    left: -panX / zoom,
    top: -panY / zoom,
    right: (-panX + w) / zoom,
    bottom: (-panY + h) / zoom,
  };
}
